import { shuffleList } from '@/modules/gameUtils/random';
import sliceListIntoChunks from '@/modules/pagination/sliceListIntoChunks';

export const questionTimer = 30;
export const resultsTimer = 5;
export const font = {
  url: 'https://fonts.googleapis.com/css2?family=Fredoka:wght@300;400;500;600;700&display=swap',
  family: 'Fredoka, sans-serif',
  weightBold: '600',
};
const gameAssetsFolder = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
  process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT == 'production'
    ? 'production'
    : 'staging'
}/games/sortImages`;

export const sortImagesAssetsFolder = gameAssetsFolder;

export const ScreenStatus = {
  audioPlaying: 'audioPlaying',
  audioPaused: 'audioPaused',
  activityPlaying: 'activityPlaying',
  activityPaused: 'activityPaused',
  resultsPlaying: 'resultsPlaying',
  resultsPaused: 'resultsPaused',
  isAudio: (questionStatus) => questionStatus?.startsWith('audio'),
  isActivity: (questionStatus) => questionStatus?.startsWith('activity'),
  isResults: (questionStatus) => questionStatus?.startsWith('results'),
  isPaused: (questionStatus) => questionStatus?.endsWith('Paused'),
  isPlaying: (questionStatus) => questionStatus?.endsWith('Playing'),
};

export function getScreenStatusToChange(screenStatus) {
  const [type, playPaused] = screenStatus.replace('P', '_P').split('_');
  return ScreenStatus[
    `${type}${playPaused == 'Playing' ? 'Paused' : 'Playing'}`
  ];
}

export function createScreens({ folder, questions, questionsPerScreen }) {
  const questionsWithAbsolutePaths = questions.map((question) => ({
    ...question,
    image: getAbsoluteImagePath(folder, question.image),
    audio: getAbsoluteAudioPath(folder, question.audio),
  }));
  const screens = sliceListIntoChunks(
    questionsWithAbsolutePaths,
    parseInt(questionsPerScreen)
  ).map((questionsChunk, index) => ({
    index,
    questions: questionsChunk,
    options: addOptionsWithIncorrectAnswers(
      questionsWithAbsolutePaths,
      questionsChunk,
      index,
      questionsPerScreen
    ),
    status: null,
  }));

  return screens;
}

export function addOptionsWithIncorrectAnswers(
  allQuestions,
  questionsChunk,
  screenIndex,
  questionsPerScreen
) {
  const incorrectImagesAvailable = getIncorrectImages(
    allQuestions,
    screenIndex,
    questionsPerScreen
  );
  let optionsCount = 0;
  const incorrectImagesCountLeft = 0; //questionsPerScreen == 4 ? 0 : 1;

  const options = questionsChunk.reduce((options, question) => {
    options.push({
      id: `${screenIndex}-${optionsCount++}`,
      questionId: question.id,
      image: question.image,
    });
    if (incorrectImagesCountLeft > 0) {
      options.push({
        id: `${screenIndex}-${optionsCount++}`,
        questionId: -question.id,
        image: incorrectImagesAvailable.pop(),
      });
      incorrectImagesCountLeft--;
    }
    return options;
  }, []);

  return shuffleList(options);
}

export function getIncorrectImages(questions, screenIndex, questionsPerScreen) {
  const minIndex = screenIndex * questionsPerScreen;
  const maxIndex = minIndex + questionsPerScreen - 1;

  const incorrectAnswers = questions
    .filter((_, idx) => idx < minIndex || idx > maxIndex)
    .map((incorrectAnswer) => incorrectAnswer.image);
  return shuffleList(incorrectAnswers);
}

export function getAbsoluteImagePath(folder, imageSrc) {
  return `${gameAssetsFolder}/${folder}/imgs/${imageSrc}`;
}

export function getAbsoluteAudioPath(folder, audioSrc) {
  return `${gameAssetsFolder}/${folder}/audios/${audioSrc}`;
}
